/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: AN9sHMOzPG9-

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import FooterTop from "../../FooterTop"; // plasmic-import: N95iCQc4Yis5/component
import FooterBottom from "../../FooterBottom"; // plasmic-import: uVCijascbjQQ/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicFooter.module.css"; // plasmic-import: AN9sHMOzPG9-/css

createPlasmicElementProxy;

export type PlasmicFooter__VariantMembers = {
  gray: "gray";
};
export type PlasmicFooter__VariantsArgs = {
  gray?: SingleBooleanChoiceArg<"gray">;
};
type VariantPropType = keyof PlasmicFooter__VariantsArgs;
export const PlasmicFooter__VariantProps = new Array<VariantPropType>("gray");

export type PlasmicFooter__ArgsType = { onContactClick?: () => void };
type ArgPropType = keyof PlasmicFooter__ArgsType;
export const PlasmicFooter__ArgProps = new Array<ArgPropType>("onContactClick");

export type PlasmicFooter__OverridesType = {
  footer?: Flex__<"footer">;
  desktopVer?: Flex__<"div">;
  content?: Flex__<"div">;
  tabletVer?: Flex__<"div">;
  mobileVer?: Flex__<"div">;
};

export interface DefaultFooterProps {
  onContactClick?: () => void;
  gray?: SingleBooleanChoiceArg<"gray">;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicFooter__RenderFunc(props: {
  variants: PlasmicFooter__VariantsArgs;
  args: PlasmicFooter__ArgsType;
  overrides: PlasmicFooter__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "gray",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.gray
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <footer
      data-plasmic-name={"footer"}
      data-plasmic-override={overrides.footer}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.footer,
        { [sty.footergray]: hasVariant($state, "gray", "gray") }
      )}
    >
      <div
        data-plasmic-name={"desktopVer"}
        data-plasmic-override={overrides.desktopVer}
        className={classNames(projectcss.all, sty.desktopVer, {
          [sty.desktopVergray]: hasVariant($state, "gray", "gray")
        })}
      >
        <div
          data-plasmic-name={"content"}
          data-plasmic-override={overrides.content}
          className={classNames(projectcss.all, sty.content)}
        >
          <FooterTop
            className={classNames("__wab_instance", sty.footerTop___3Rx77)}
            onContactClick={args.onContactClick}
          />

          <FooterBottom
            className={classNames("__wab_instance", sty.footerBottom___9Pav)}
          />
        </div>
      </div>
      <div
        data-plasmic-name={"tabletVer"}
        data-plasmic-override={overrides.tabletVer}
        className={classNames(projectcss.all, sty.tabletVer, {
          [sty.tabletVergray]: hasVariant($state, "gray", "gray")
        })}
      >
        <FooterTop
          className={classNames("__wab_instance", sty.footerTop__v1Owx)}
          onContactClick={async () => {
            const $steps = {};

            $steps["runOnContactClick"] = true
              ? (() => {
                  const actionArgs = { eventRef: $props["onContactClick"] };
                  return (({ eventRef, args }) => {
                    return eventRef?.(...(args ?? []));
                  })?.apply(null, [actionArgs]);
                })()
              : undefined;
            if (
              $steps["runOnContactClick"] != null &&
              typeof $steps["runOnContactClick"] === "object" &&
              typeof $steps["runOnContactClick"].then === "function"
            ) {
              $steps["runOnContactClick"] = await $steps["runOnContactClick"];
            }
          }}
        />

        <FooterBottom
          className={classNames("__wab_instance", sty.footerBottom__h0Voo)}
        />
      </div>
      {(
        hasVariant(globalVariants, "mobile", "mobile")
          ? true
          : hasVariant(globalVariants, "mobile", "tabletPortrait")
          ? true
          : false
      ) ? (
        <div
          data-plasmic-name={"mobileVer"}
          data-plasmic-override={overrides.mobileVer}
          className={classNames(projectcss.all, sty.mobileVer, {
            [sty.mobileVergray]: hasVariant($state, "gray", "gray")
          })}
        >
          <FooterTop
            className={classNames("__wab_instance", sty.footerTop__lxFnc)}
            onContactClick={async () => {
              const $steps = {};

              $steps["runOnContactClick"] = true
                ? (() => {
                    const actionArgs = { eventRef: $props["onContactClick"] };
                    return (({ eventRef, args }) => {
                      return eventRef?.(...(args ?? []));
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["runOnContactClick"] != null &&
                typeof $steps["runOnContactClick"] === "object" &&
                typeof $steps["runOnContactClick"].then === "function"
              ) {
                $steps["runOnContactClick"] = await $steps["runOnContactClick"];
              }
            }}
          />

          <FooterBottom
            className={classNames("__wab_instance", sty.footerBottom__yNlit)}
          />
        </div>
      ) : null}
    </footer>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  footer: ["footer", "desktopVer", "content", "tabletVer", "mobileVer"],
  desktopVer: ["desktopVer", "content"],
  content: ["content"],
  tabletVer: ["tabletVer"],
  mobileVer: ["mobileVer"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  footer: "footer";
  desktopVer: "div";
  content: "div";
  tabletVer: "div";
  mobileVer: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicFooter__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicFooter__VariantsArgs;
    args?: PlasmicFooter__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicFooter__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicFooter__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFooter__ArgProps,
          internalVariantPropNames: PlasmicFooter__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFooter__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "footer") {
    func.displayName = "PlasmicFooter";
  } else {
    func.displayName = `PlasmicFooter.${nodeName}`;
  }
  return func;
}

export const PlasmicFooter = Object.assign(
  // Top-level PlasmicFooter renders the root element
  makeNodeComponent("footer"),
  {
    // Helper components rendering sub-elements
    desktopVer: makeNodeComponent("desktopVer"),
    content: makeNodeComponent("content"),
    tabletVer: makeNodeComponent("tabletVer"),
    mobileVer: makeNodeComponent("mobileVer"),

    // Metadata about props expected for PlasmicFooter
    internalVariantProps: PlasmicFooter__VariantProps,
    internalArgProps: PlasmicFooter__ArgProps
  }
);

export default PlasmicFooter;
/* prettier-ignore-end */
